<template>
    <div class="video-page">
        <div class="video-page__video">
            <div class="video-page__thumbnail" />

            <div class="video-page__video-actions">
                <h1>
                    Could not find the video you are looking for.
                </h1>
                <p>
                    The video you are looking for is either not available or has been removed.
                </p>
                <div class="video-page__buttons video-page__buttons--centered">
                    <BaseButton
                        v-if="!loggedIn"
                        class="video-page__video-access"
                        icon-left="play"
                        tabindex="-1"
                        @click="modalStore.toggleModal(MODAL_LOGIN);"
                    >
                        Create a free account
                    </BaseButton>
                    <BaseButton
                        v-if="!loggedIn"
                        class="base-button--content-only base-button--outline"
                        icon-left="lock"
                        tabindex="-1"
                        aria-hidden="true"
                        @click="modalStore.toggleModal(MODAL_LOGIN);"
                    >
                        Login
                    </BaseButton>
                    <BaseButton
                        v-if="loggedIn"
                        :element="defineNuxtLink({})"
                        to="/"
                        class="video-page__videos-back"
                        icon-left="arrow-left"
                        tabindex="-1"
                        aria-hidden="true"
                    >
                        Return to videos
                    </BaseButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useModalStore, MODAL_LOGIN } from '~/store/modal';

const modalStore = useModalStore();

defineProps({
    loggedIn: {
        type: Boolean,
        default: false
    }
});
</script>

<style lang="less" src="./VideoPage.less" />

<style lang="less" scoped>
.video-page__body > .base-button--content-only {
    color: var(--color-lightest);

    @media @q-md-max {
        margin: 0 auto var(--spacing-md);
    }

    @media @q-md-min {
        margin-bottom: var(--spacing-xl);
        padding-left: 0;
    }
}

.video-page__thumbnail {
    position: absolute;
    width: 100%;
    height: 100%;

    :deep(img) {
        height: 100%;
        width: 100%;
        object-fit: cover;
        background-color: var(--color-primary);
    }

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(180deg, rgba(9, 40, 43, 0.53) 0%, #082528 100%);

    }
}

.video-page__video {
    position: relative;
}

.video-page__video-actions {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: var(--spacing-xs);
    flex-direction: column;

    @media @q-md-min {
        gap: var(--spacing-sm);
        justify-content: center;
    }
}

.video-page__video-lock {
    white-space: nowrap;
    color: var(--color-lightest);

    @media @q-md-max {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

.video-page__video-access {
    @media @q-md-max {
        width: 100%;
        justify-content: center;
    }
}

.video-page__body {
    display: block;
}

.video-page__buttons {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
    margin-top: var(--spacing-lg);

    &--centered {
        margin-top: 0;
        justify-content: center;
        align-items: center;
    }
}
</style>
